export default {
  blank: () => import("/app/layouts/blank.vue"),
  conversation: () => import("/app/layouts/conversation.vue"),
  default: () => import("/app/layouts/default.vue"),
  login: () => import("/app/layouts/login.vue")
}